import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {FormattedMessage, useIntl} from "react-intl";

// @mui/material components
import Grid from "@mui/material/Grid";
import {Tooltip} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// core components
import TrashIcon from "components/icons/TrashIcon";

// style
import {red500} from "assets/jss/main";
import stripeLogoOk from "assets/img/stripe-logo-ok.svg";
import stripeLogoKo from "assets/img/stripe-logo-ko.svg";
import pushActive from "assets/img/push-active.svg";
import pushNotActive from "assets/img/push-not-active.svg";
import pushWithoutStripe from "assets/img/push-without-stripe.svg";
import editIcon from "assets/img/edit-2.svg";

// utils
import {Authorizations, hasAuthorization} from "utils/authorizations";

RetailerActionsCell.propTypes = {
    retailer: PropTypes.object.isRequired,
    del: PropTypes.func,
    createStripe: PropTypes.func,
    authorizations: PropTypes.array,
    stripeLoading: PropTypes.bool,
};

function RetailerActionsCell({retailer, del, createStripe, authorizations, stripeLoading}) {
    const intl = useIntl();

    const isStripeEnabled = retailer['paymentAccount'] && retailer['paymentAccount']['enabled'] === true;

    const getPushIcon = () => {
        if (!retailer['pushActive']) return pushNotActive;
        if (isStripeEnabled) return pushActive;
        if (retailer['pushWithoutStripe']) return pushWithoutStripe;
        return pushNotActive;
    };

    const getPushTooltip = () => {
        if (!retailer['pushActive']) return "retailer.list.table.tooltip.pushNotActive";
        if (isStripeEnabled) return "retailer.list.table.tooltip.pushActive";
        if (retailer['pushWithoutStripe']) return "retailer.list.table.tooltip.pushWithoutStripe";
        return "retailer.list.table.tooltip.pushNotActive";
    };

    return (
        <Grid
            item
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{width: '160px', gap: '8px'}}
            flexWrap={"nowrap"}
        >
            {hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT) &&
                <Tooltip title={<FormattedMessage id={"retailer.list.table.tooltip.delete"} />}>
                    <div onClick={() => del(retailer)} style={{cursor: "pointer", display: "flex", alignItems: "center"}}>
                        <TrashIcon color={red500} size={20} />
                    </div>
                </Tooltip>
            }
            {hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT) &&
                <Link to={`edit/${encodeURIComponent(retailer.id)}`} style={{display: "flex", alignItems: "center"}}>
                    <Tooltip title={<FormattedMessage id={"retailer.list.table.tooltip.edit"} />}>
                        <img src={editIcon} alt="Edit" style={{width: 20, height: 20, cursor: "pointer"}} />
                    </Tooltip>
                </Link>
            }
            {hasAuthorization(authorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT) &&
                <div style={{display: "flex", alignItems: "center"}}>
                    {isStripeEnabled ?
                        <Tooltip title={<FormattedMessage id={"retailer.list.table.tooltip.stripe.enable"} />}>
                            <img src={stripeLogoOk} alt="Stripe enabled" style={{width: 20, height: 20, cursor: "default"}} />
                        </Tooltip>
                        :
                        <div onClick={() => {
                            if (!stripeLoading && window.confirm(intl.formatMessage({id: "retailer.list.table.action.confirm"}))) {
                                createStripe(retailer);
                            }
                        }} style={{display: "flex", alignItems: "center"}}>
                            <Tooltip title={<FormattedMessage id={"retailer.list.table.tooltip.stripe.disable"} />}>
                                {stripeLoading ?
                                    <CircularProgress size={20} />
                                    :
                                    <img src={stripeLogoKo} alt="Stripe disabled" style={{width: 20, height: 20, cursor: "pointer"}} />
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
            }
            <Tooltip title={<FormattedMessage id={getPushTooltip()} />}>
                <img src={getPushIcon()} alt="Push status" style={{width: 20, height: 20, cursor: "default"}} />
            </Tooltip>
        </Grid>
    );
}

export default RetailerActionsCell;
